import moment from "moment";
import * as bootstrap from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
    checkTasks();
});
document.addEventListener('turbo:load', () => {
    checkTasks();
})

function checkTasks() {
    const container = document.getElementById('modal');
    if (!container) {
        return
    }
    const tasks = JSON.parse(container.dataset.tasks);
    if (tasks.length === 0) {
        return
    }

    container.innerHTML = '';
    container.appendChild(buildTaskModal(tasks));

    const modal = new bootstrap.Modal(container.querySelector('.modal'));
    modal.show();
}

function buildTaskModal(tasks) {
    const wrapper = document.createElement('div');
    wrapper.className = 'modal';
    wrapper.id = 'application-modal-1';
    wrapper.tabIndex = -1;
    wrapper.setAttribute('role', 'dialog');
    wrapper.setAttribute('aria-modal', 'true');
    wrapper.setAttribute('aria-labelledby', 'ModalLabel');
    wrapper.innerHTML = `<div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="ModalLabel">You Have Pending Tasks!</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>`;

    wrapper.querySelector('.modal-body').appendChild(buildTaskList(tasks));

    return wrapper;
}

function buildTaskList(tasks) {
    const list = document.createElement('ul');
    tasks.forEach(task => {
        const item = document.createElement('li');
        item.appendChild(document.createTextNode(`${moment(task.due).format('MM/DD/YYYY')} `));

        const link = document.createElement('a');
        link.href = `/tasks/${task.id}`;
        link.textContent = task.title;
        item.appendChild(link);

        list.appendChild(item);
    });
    return list;
}
